import { TemplateResult, html, CSSResultGroup } from 'lit';
import { SlotController } from '../../controllers/slot-controller';
import { BlocksElement } from '../BlocksElement';
import styles from './footer.styles';

/**
 * @slot default - The footer content
 * @slot top - The top content (above the default slot)
 * @slot bottom - The bottom content (below the default slot)
 * @csspart base - The component's base wrapper.
 * @csspart top-wrapper - The component's top wrapper.
 * @csspart part-top - The component's top slot.
 * @csspart middle-wrapper - The component's middle wrapper.
 * @csspart part-default - The component's default slot.
 * @csspart bottom-wrapper - The component's bottom wrapper.
 * @csspart part-bottom - The component's bottom slot.
 */
export class BlocksFooter extends BlocksElement {static styles: CSSResultGroup = styles;

  protected slots = new SlotController(this, 'top', 'bottom', null);

  render(): TemplateResult<1> {
    const componentClassName = this.componentClassNames('cat-c-footer', {
      'cat-c-footer--has-top-slot': this.slots.hasSlotted('top'),
      'cat-c-footer--has-bottom-slot': this.slots.hasSlotted('bottom')
    });

    return html`
      <footer part="base" class="${componentClassName}" role="contentinfo">
        <div part="top-wrapper" class="cat-c-footer__top">
          <slot part="part-top" name="top"></slot>
        </div>
        <div part="middle-wrapper" class="cat-c-footer__middle">
          <slot part="part-default"></slot>
        </div>
        <div part="bottom-wrapper" class="cat-c-footer__bottom">
          <slot part="part-bottom" name="bottom"></slot>
        </div>
      </footer>
    `;
  }
}

if (customElements.get('cat-footer') === undefined) {
  customElements.define('cat-footer', BlocksFooter);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-footer': BlocksFooter;
  }
}
